import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { IProduct, IProductAttachment } from '../../../types/product';
import { Box } from '@mui/material';
import { DeleteProductDialog } from '../../Dialog/DeleteProductDialog';

export const getCustomerAppProductColumns = (section: string): GridColDef[] => {
  return [
    {
      field: 'sKU',
      headerName: 'SKU',
      minWidth: 150,
    },
    {
      field: 'name',
      headerName: 'Name',
      minWidth: 150,
    },
    {
      field: 'totalstock',
      headerName: 'Total Stock',
      minWidth: 150,
    },
    {
      field: 'attachments',
      headerName: 'Thumbnail',
      minWidth: 150,
      renderCell: (params: GridRenderCellParams) => {
        const row = params.row as IProduct;
        const defaultImg = row.attachments?.find((x: IProductAttachment) => x.isDefault);
        return (
          <>
            <Box
              component="img"
              src={defaultImg?.downloadUrl}
              alt="No default img"
              sx={{
                height: 80,
                width: 100,
                maxWidth: '100%',
                objectFit: 'contain',
              }}
            />
          </>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      minWidth: 150,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <DeleteProductDialog data={params.row} section={section} />
          </>
        );
      },
    },
  ];
};
